<template>
  <div id="tab-gathering-trailer">
    <el-form
      :disabled="readonly"
      class="section"
      style="flex-direction: row;width: fit-content;min-width: 1345px"
    >
      <el-checkbox
        v-model="form.landTransportation"
        no="landTransportation"
        @change="pm.loadingTermChange('landTransportation')"
      >{{ $t('Partners.doorInformation') }}
      </el-checkbox>
      <el-checkbox
        v-model="form.dischargingPortDoor"
        no="dischargingPortDoor"
        style="margin-left: -20px;"
      >{{ $t('CargoMsg.Cargo_DestinationDelivery') }}
      </el-checkbox>
      <el-checkbox
        v-model="form.warehousing"
        no="warehousing"
        style="margin-left: -20px;"
        @change="pm.loadingTermChange('warehousing')"
      >{{ $t('SeaExport.WarehouseLoading') }}
      </el-checkbox>
      <el-checkbox
        v-model="form.customs"
        no="customs"
        style="margin-left: -20px;"
        @change="val=>{form.customsBroker=val?form.customsBroker:0;form.customsDeclarationType=val?form.customsDeclarationType:-1}"
      >{{ $t('SeaExport.CustomsDeclaration') }}
      </el-checkbox>
      <el-checkbox v-model="form.insure" no="isInsure" style="margin-left: -20px;">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
      <div v-if="!!templateName" style="flex-grow: 1;">
        <span class="blue" style="float: right;margin-right: 30px;padding: 0 5px;white-space: nowrap;">{{ $t('CargoMsg.Cargo_SopTemplate') }}: {{ templateName }}</span>
      </div>
    </el-form>
    <div style="width: fit-content">
      <tab-international-card-base-master-UICustom-layout :element-blocks="elementBlocks" :disabled="readonly">
        <el-form-item v-if="elementDict.jobNo.viewable" slot="jobNo">
          <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
          <el-input :value="form.jobNo" :disabled="true" />
        </el-form-item>
        <template v-if="isZY">
          <el-form-item slot="saleProductCode">
            <line-label slot="label" class="blue" :label="$t('SeaExport.AllowSaleProduct')" />
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_AllowSaleProduct"
              filterable
              no="allowSaleProduct"
              clearable
              :data-filter-function="p => p.statusEnabled && p.intergraed"
              :default-value="form.saleProductCode || ''"
              @parentCallBack="p => {form.saleProductCode = p.value}"
            />
          </el-form-item>
          <el-form-item slot="fullOrInside">
            <line-label slot="label" class="blue" :label="$t('SeaExport.FullOrInside')" />
            <cargo-advance-select
              :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
              no="fullOrInside"
              clearable
              :default-value="form.fullOrInside || ''"
              @parentCallBack="p => {form.fullOrInside = p.value}"
            />
          </el-form-item>
        </template>
        <!--综合物流订单类型-->
        <el-form-item v-if="elementDict.containerLoadType.viewable" slot="containerLoadType">
          <line-label slot="label" :class="elementDict.containerLoadType.isRequire ? 'blue' : ''" :label="elementDict.containerLoadType.label" />
          <el-select
            :value="form.containerLoadType"
            no="containerLoadType"
            :disabled="isSelectDisabled || !elementDict.customerId.writable"
            @change="val=>{pm.containerLoadTypeChange(val)}"
          >
            <el-option
              v-for="(item,index) in (containerLoadTypes)"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <!--操作模式-->
        <el-form-item v-if="elementDict.operateType.viewable" slot="operateType">
          <line-label slot="label" :class="elementDict.operateType.isRequire ? 'blue' : ''" :label="elementDict.operateType.label" />
          <el-select
            :value="form.operateType"
            no="operateType"
            :disabled="true"
            @change="val=>{pm.operateTypeChange(val)}"
          >
            <el-option
              v-for="(item,index) in (operateTypes)"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.transportType.viewable" slot="transportType">
          <line-label slot="label" :class="elementDict.transportType.isRequire ? 'blue' : ''" :label="elementDict.transportType.label" />
          <cargo-advance-select
            no="cargoType"
            :select-type="selectTypeNames.basic_data_TransportType"
            :method-params="{ie:true}"
            filterable
            :clearable="false"
            :disabled="!elementDict.transportType.writable"
            :default-value="form.transportType"
            @parentCallBack="p=>{form.transportType=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.businessDate.viewable" slot="businessDate">
          <line-label slot="label" :class="elementDict.businessDate.isRequire ? 'blue' : ''" :label="elementDict.businessDate.label" />
          <div style="display: flex">
            <el-date-picker
              no="businessDate"
              class="departure-date-picker"
              :value="form.businessDate"
              type="date"
              value-format="yyyy-MM-dd"
              :disabled="!elementDict.businessDate.writable"
              style="flex: 1;margin-right: 5px"
              @input="businessDateChange"
            />&nbsp;
            <span>{{ form.businessDateDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.etd.viewable" slot="etd">
          <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
          <div style="display: flex">
            <el-date-picker
              no="etd"
              class="departure-date-picker"
              :value="form.etd"
              :disabled="!elementDict.etd.writable"
              type="date"
              value-format="yyyy-MM-dd"
              style="flex: 1;margin-right: 5px"
              @input="etdChange"
            />&nbsp;
            <span>{{ form.sailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.atd.viewable" slot="atd">
          <line-label slot="label" :class="elementDict.atd.isRequire ? 'blue' : ''" :label="elementDict.atd.label" />
          <div style="display: flex">
            <el-date-picker
              :value="form.atd"
              :disabled="!elementDict.atd.writable"
              no="atd"
              style="flex: 1;margin-right: 5px"
              type="date"
              value-format="yyyy-MM-dd"
              @input="atdChange"
            />
            <span>{{ form.atdSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.eta.viewable" slot="eta">
          <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="form.eta"
              :disabled="!elementDict.eta.writable"
              no="eta"
              style="flex: 1;margin-right: 5px"
              type="date"
              value-format="yyyy-MM-dd"
              @input="etaChange"
            />
            <span>{{ form.etaSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.ata.viewable" slot="ata">
          <line-label slot="label" :class="elementDict.ata.isRequire ? 'blue' : ''" :label="elementDict.ata.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="form.ata"
              :disabled="!elementDict.ata.writable"
              no="ata"
              style="flex: 1;margin-right: 5px"
              type="date"
              value-format="yyyy-MM-dd"
              @input="ataChange"
            />
            <span>{{ form.ataSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.customsDate.viewable" slot="customsDate">
          <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
          <el-date-picker
            v-model="form.customsDate"
            :disabled="!elementDict.customsDate.writable"
            no="customsDate"
            type="date"
            style="width:100%"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dispatchingPlaceCode.viewable" slot="dispatchingPlaceCode">
          <line-label slot="label" :class="elementDict.dispatchingPlaceCode.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlaceCode.label" />
          <cargo-advance-select
            no="dispatchingPlaceCode"
            :select-type="selectTypeNames.basic_data_Seaport"
            :placeholder="$t('SeaExport.PlaceHolderPOR')"
            :disabled="!elementDict.dispatchingPlaceCode.writable"
            filterable
            :default-value="form.dispatchingPlaceCode"
            tag-name="englishName"
            style="flex:1"
            @parentCallBack="p=>{pm.changeDispatchingPlaceCode(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dispatchingPlace.viewable" slot="dispatchingPlace">
          <line-label slot="label" :class="elementDict.dispatchingPlace.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlace.label" />
          <el-input
            v-model="form.dispatchingPlace"
            no="dispatchingPlace"
            :disabled="!elementDict.dispatchingPlace.writable"
            @change="pm.changeDispatchingPlace()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.loadingPortCode.viewable" slot="loadingPortCode">
          <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
          <div style="display: flex; justify-content: space-between">
            <cargo-advance-select
              ref="loadingPortCode"
              no="loadingPortCode"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :default-value="form.loadingPortCode"
              tag-name="englishName"
              :disabled="!elementDict.loadingPortCode.writable"
              style="flex:1"
              @parentCallBack="p=>{loadingPortCodeCharge(p);pm.setPlannerChange()}"
            />&nbsp;
            <el-checkbox v-model="form.transfering" no="transfering" style="padding-left:2px;" :disabled="!elementDict.loadingPortCode.writable">{{ $t('SeaExport.Transit') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.transferPortCode.viewable && form.transfering" slot="transferPortCode">
          <line-label slot="label" :class="elementDict.transferPortCode.isRequire ? 'blue' : ''" :label="elementDict.transferPortCode.label" />
          <cargo-advance-select
            no="transferPortCode"
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :disabled="!elementDict.transferPortCode.writable"
            :default-value="form.transferPortCode"
            @parentCallBack="p=>{form.transferPortCode=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dischargingPortCode.viewable" slot="dischargingPortCode">
          <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
          <cargo-advance-select
            no="dischargingPortCode"
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :disabled="!elementDict.dischargingPortCode.writable"
            :default-value="form.dischargingPortCode"
            @parentCallBack="p=>{form.dischargingPortCode=p.value;pm.dischargingPortCodeChange(p.value);}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.waybillDestination.viewable" slot="waybillDestination">
          <line-label slot="label" :class="elementDict.waybillDestination.isRequire ? 'blue' : ''" :label="elementDict.waybillDestination.label" />
          <el-input
            v-model="form.waybillDestination"
            no="waybillDestination"
            type="textarea"
            :rows="5"
            :disabled="!elementDict.waybillDestination.writable"
            @change="pm.changeDispatchingPlace()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.carrierId.viewable" slot="carrierId">
          <line-label slot="label" :class="elementDict.carrierId.isRequire ? 'blue' : ''" :label="elementDict.carrierId.label" />
          <cargo-company-select
            no="carrierId"
            :disabled="!carrierIdEnabled || !elementDict.carrierId.writable"
            :method-params="{truckCmp:true,active:true,companyLob:'integratedJob'}"
            :default-value="form.carrierId||''"
            @change="p=>{form.carrierId=p.value;onCarrierIdChange()}"
            @blur="pm.carrierFocusOutEventHandler()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.polCountry.viewable" slot="polCountry">
          <line-label slot="label" :class="elementDict.polCountry.isRequire ? 'blue' : ''" :label="elementDict.polCountry.label" />
          <el-input v-model="form.polCountry" no="polCountry" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoSource.viewable" slot="cargoSource">
          <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
          <el-select
            v-model="form.cargoSource"
            no="cargoSource"
            :disabled="!cargoSourceEnabled || !elementDict.cargoSource.writable"
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
            @change="form.designationAgent=0;pm.cargoSourceChange({fieldName:'cargoSource'})"
          >
            <el-option
              v-for="(item,index) in CARGO_SOURCES"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
        <!--自定义业务类型-->
        <el-form-item v-if="elementDict.customJobType.viewable" slot="customJobType">
          <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
          <cargo-advance-select
            ref="customJobType"
            no="customJobType"
            :select-type="selectTypeNames.basic_data_CutomJobType"
            :disabled="!elementDict.customJobType.writable"
            filterable
            :default-value="form.customJobType"
            :method-params="{type:form.lob}"
            :tag-name="isZh?'name':'englishName'"
            :static-options="customJobTypeList"
            @parentCallBack="p=>{form.customJobType=p.value;onCustomJobTypeChange();contractRuleFieldChange()}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customJobType.viewable && form.customJobType && secondaryCustomJobTypeList.length > 0">
          <line-label slot="label" :class="elementDict.secondaryCustomJobType.isRequire ? 'blue' : ''" :label="elementDict.secondaryCustomJobType.label" />
          <cargo-advance-select
            ref="secondaryCustomJobType"
            no="secondaryCustomJobType"
            :select-type="selectTypeNames.basic_data_CutomJobType"
            :disabled="!elementDict.customJobType.writable"
            filterable
            :cache="false"
            :default-value="form.secondaryCustomJobType"
            :tag-name="isZh?'name':'englishName'"
            :static-options="secondaryCustomJobTypeList"
            @parentCallBack="p=>{form.secondaryCustomJobType=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.transportSource.viewable" slot="transportSource">
          <line-label slot="label" :class="elementDict.transportSource.isRequire ? 'blue' : ''" :label="elementDict.transportSource.label" />
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_TransportSource"
            :disabled="!elementDict.transportSource.writable"
            no="transportSource"
            :default-value="form.transportSource"
            :cache="false"
            tag-value="code"
            placeholder=" "
            @parentCallBack="item=>form.transportSource=item.value"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.statisticArea.viewable" slot="statisticArea">
          <line-label slot="label" :class="elementDict.statisticArea.isRequire ? 'blue' : ''" :label="elementDict.statisticArea.label" />
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_StatisticArea"
            :disabled="!elementDict.statisticArea.writable"
            no="statisticArea"
            :default-value="form.statisticArea"
            :cache="false"
            tag-value="code"
            placeholder=" "
            @parentCallBack="item=>form.statisticArea=item.value"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.destinationAgent.viewable" slot="destinationAgent">
          <line-label slot="label" :class="elementDict.destinationAgent.isRequire ? 'blue' : ''" :label="elementDict.destinationAgent.label" />
          <div style="display: flex;align-items: center">
            <el-tooltip
              v-show="sopImageC"
              :content="$t('SeaExport.SOPReceiver')"
              placement="right-end"
            >
              <img
                :class="form.destinationAgent&&readonly?'':'not-click'"
                :src="sopPic"
                width="18"
                height="28"
                style="padding: 5px 0;cursor: pointer"
                @click="pm.sopChangeHandler()"
              >
            </el-tooltip>
            <el-tooltip
              v-show="showWarningImageC"
              :content="warningImageCTip"
              placement="right-end"
            >
              <i
                class="el-icon-warning red"
                style="cursor: pointer"
              />
            </el-tooltip>
            <cargo-advance-select
              no="destinationAgent"
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{overseaAgent:true,companyLob:'integratedJob',active:true}"
              :default-value="form.destinationAgent||''"
              :disabled="!elementDict.destinationAgent.writable"
              filterable
              :headers="[$t('Partners.englishName')]"
              :fields="['englishName']"
              tag-name="englishName"
              @parentCallBack="p=>{pm.txtDestinationAgentChangeHandler(p)}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.designationAgent.viewable && form.cargoSource === 'NC'" slot="designationAgent">
          <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
          <div style="display: flex;align-items: center">
            <el-tooltip
              v-show="sopImageA"
              :content="$t('SeaExport.SOPReceiver')"
              placement="right-end"
            >
              <div>
                <img
                  :class="form.designationAgent&&readonly?'':'not-click'"
                  :src="sopPic"
                  width="18"
                  height="28"
                  style="padding: 5px 0;cursor: pointer"
                  @click="pm.sopChangeBookingAgentHandler()"
                >
              </div>
            </el-tooltip>
            <el-tooltip v-show="showWarningImageA" :content="warningImageATip" placement="right-end">
              <i class="el-icon-warning red" style="cursor: pointer" />
            </el-tooltip>
            <cargo-advance-select
              no="designationAgent"
              class="designation-agent-selector"
              popper-class="designation-agent-selector-popper"
              :select-type="selectTypeNames.basic_data_Company"
              :disabled="!designationAgentEnabled || !elementDict.designationAgent.writable"
              :method-params="{designationAgent:true,companyLob:'integratedJob',active:true}"
              :check-credit="true"
              :default-value="form.designationAgent||''"
              filterable
              :headers="[$t('Partners.englishName')]"
              :fields="['englishName']"
              tag-name="englishName"
              @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.bookingAgent.viewable" slot="bookingAgent">
          <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
          <cargo-advance-select
            no="bookingAgent"
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{bookingAgent:true,companyLob:'integratedJob',active:true}"
            filterable
            :disabled="!elementDict.bookingAgent.writable"
            :default-value="form.bookingAgent||''"
            @parentCallBack="p=>{form.bookingAgent=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.transferAgent.viewable" slot="transferAgent">
          <line-label slot="label" :class="elementDict.transferAgent.isRequire ? 'blue' : ''" :label="elementDict.transferAgent.label" />
          <cargo-advance-select
            no="transferAgent"
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{portAgent:true,companyLob:'integratedJob',active:true}"
            filterable
            :disabled="!elementDict.transferAgent.writable"
            :default-value="form.transferAgent||''"
            @parentCallBack="p=>{form.transferAgent=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customerRefNo.viewable" id="customerRefNo" slot="customerRefNo">
          <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
          <el-tooltip
            :disabled="!customerRefNoTip"
            :content="customerRefNoTip"
            placement="right-end"
          >
            <el-input
              v-model="form.customerRefNo"
              no="customerRefNo"
              :disabled="!elementDict.customerRefNo.writable"
              :class="customerRefNoTip?'red':''"
              @blur="pm.customerRefNoFocusOutHandler()"
            />
          </el-tooltip>
        </el-form-item>
        <el-form-item v-if="elementDict.poNo.viewable" slot="poNo" :class="poNoRed?'poNoClass':''">
          <line-label slot="label" :class="elementDict.poNo.isRequire ? 'blue' : ''" :label="elementDict.poNo.label" />
          <el-input
            v-if="!openProjectConfig"
            v-model="form.poNo"
            :disabled="!elementDict.poNo.writable"
            no="poNo"
          />
          <cargo-project-select
            v-if="openProjectConfig"
            no="poNo"
            :default-value="form.poNo"
            :customer-id="form.customerId"
            :disabled="!elementDict.poNo.writable"
            :is-linked="isProjectLinkedCustomer"
            @change="p=>{form.poNo=p.value;form.projectName=p.projectName}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.projectName.viewable && openProjectConfig" slot="projectName">
          <line-label slot="label" :class="elementDict.projectName.isRequire ? 'blue' : ''" :label="elementDict.projectName.label" />
          <el-input v-model="form.projectName" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.projectBatch.viewable && openProjectConfig" slot="projectBatch">
          <line-label slot="label" :class="elementDict.projectBatch.isRequire ? 'blue' : ''" :label="elementDict.projectBatch.label" />
          <el-input v-model="form.projectBatch" no="projectBatch" :disabled="!elementDict.projectBatch.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.customsBroker.viewable" slot="customsBroker">
          <line-label slot="label" :class="elementDict.customsBroker.isRequire ? 'blue' : ''" :label="elementDict.customsBroker.label" />
          <cargo-advance-select
            no="customsBroker"
            :disabled="!customsBrokerEnabled || !elementDict.customsBroker.writable"
            :select-type="selectTypeNames.basic_data_Company"
            :data-filter-function="customsBrokerFilter"
            filterable
            :default-value="form.customsBroker||''"
            :placeholder="!customsBrokerEnabled? $t('SeaExport.PleaseTickCustomsDeclarationOption'):$t('CargoMsg.Cargo_keyWordsTip')"
            :method-params="{customsBroker:true,companyLob:'integratedJob',active:true}"
            @parentCallBack="p=>{form.customsBroker=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customsDeclarationType.viewable" slot="customsDeclarationType">
          <line-label slot="label" :class="elementDict.customsDeclarationType.isRequire ? 'blue' : ''" :label="elementDict.customsDeclarationType.label" />
          <cargo-advance-select
            no="customsDeclarationType"
            :disabled="!customsBrokerEnabled || !elementDict.customsDeclarationType.writable"
            :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
            filterable
            :default-value="form.customsDeclarationType===-1?'':form.customsDeclarationType"
            :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
            @parentCallBack="p=>{form.customsDeclarationType=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customsMethodPol.viewable" slot="customsMethodPol">
          <line-label slot="label" :class="elementDict.customsMethodPol.isRequire ? 'blue' : ''" :label="elementDict.customsMethodPol.label" />
          <cargo-advance-select
            no="customsMethodPol"
            :disabled="!customsBrokerEnabled || !elementDict.customsMethodPol.writable"
            :select-type="selectTypeNames.basic_data_CustomsMode"
            :method-params="{serviceType:2}"
            filterable
            :clearable="false"
            :default-value="form.customsMethodPol"
            @parentCallBack="p=>{form.customsMethodPol=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.tradeTerm.viewable" slot="tradeTerm">
          <line-label slot="label" :class="elementDict.tradeTerm.isRequire ? 'blue' : ''" :label="elementDict.tradeTerm.label" />
          <cargo-advance-select
            no="tradeTerm"
            :select-type="selectTypeNames.basic_data_TradeTerm"
            filterable
            :default-value="form.tradeTerm"
            :disabled="!elementDict.tradeTerm.writable"
            @parentCallBack="p=>{form.tradeTerm=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.carryingCmp.viewable" slot="carryingCmp">
          <line-label slot="label" :class="elementDict.carryingCmp.isRequire ? 'blue' : ''" :label="elementDict.carryingCmp.label" />
          <cargo-company-select
            no="carryingCmp"
            :disabled="!form.landTransportation || !elementDict.carryingCmp.writable"
            :method-params="{truckCmp:true,active:true,companyLob:'integratedJob'}"
            :default-value="form.carryingCmp||''"
            :placeholder="!form.landTransportation?$t('SeaExport.PleaseTickDoorLoadingDeliveryOption'):$t('CargoMsg.Cargo_keyWordsTip')"
            @change="p=>{pm.carryingCmpChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.warehouseCmp.viewable" slot="warehouseCmp">
          <line-label slot="label" :class="elementDict.warehouseCmp.isRequire ? 'blue' : ''" :label="elementDict.warehouseCmp.label" />
          <cargo-company-select
            no="warehouseCmp"
            :disabled="!warehouseEabled || !elementDict.warehouseCmp.writable"
            :method-params="{warehouse:true,active:true,companyLob:'integratedJob'}"
            :default-value="form.warehouseCmp||''"
            :placeholder="!warehouseEabled? $t('SeaExport.PleaseSelectWarehouse'): $t('CargoMsg.Cargo_keyWordsTip')"
            @change="p=>{pm.warehouseCmpChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.warehouseName.viewable && openWarehouse" slot="warehouseName">
          <line-label slot="label" :class="elementDict.warehouseName.isRequire ? 'blue' : ''" :label="elementDict.warehouseName.label" />
          <el-select
            ref="warehouseName"
            v-model="form.warehouseName"
            no="warehouseName"
            :disabled="!warehouseEabled||!form.warehouseCmp || !elementDict.warehouseName.writable"
            :allow-create="true"
            filterable
            :clearable="true"
            @change="warehouseNameChangeHandler"
          >
            <el-option
              v-for="(item,index) in warehouseNameList"
              :key="index"
              :label="item.warehouseName"
              :value="item.warehouseName"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.salePriceRemarks.viewable" slot="salePriceRemarks">
          <line-label slot="label" :class="elementDict.salePriceRemarks.isRequire ? 'blue' : ''" :label="elementDict.salePriceRemarks.label" />
          <el-input v-model="form.salePriceRemarks" no="salePriceRemarks" :disabled="!elementDict.salePriceRemarks.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.freeDemurrage.viewable" slot="freeDemurrage">
          <line-label slot="label" :class="elementDict.freeDemurrage.isRequire ? 'blue' : ''" :label="elementDict.freeDemurrage.label" />
          <el-input v-model="form.freeDemurrage" no="freeDemurrage" :disabled="!elementDict.freeDemurrage.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.freeDetention.viewable" slot="freeDetention">
          <line-label slot="label" :class="elementDict.freeDetention.isRequire ? 'blue' : ''" :label="elementDict.freeDetention.label" />
          <el-input v-model="form.freeDetention" no="freeDetention" :disabled="!elementDict.freeDetention.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.customsAreaApplication.viewable" slot="customsAreaApplication">
          <line-label slot="label" :class="elementDict.customsAreaApplication.isRequire ? 'blue' : ''" :label="elementDict.customsAreaApplication.label" />
          <el-input v-model="form.customsAreaApplication" no="customsAreaApplication" :disabled="!elementDict.customsAreaApplication.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.incoTerm.viewable" slot="incoTerm">
          <line-label slot="label" :class="elementDict.incoTerm.isRequire ? 'blue' : ''" :label="elementDict.incoTerm.label" />
          <cargo-advance-select
            no="incoTerm"
            :select-type="selectTypeNames.basic_data_IncoTerm"
            filterable
            :disabled="!elementDict.incoTerm.writable"
            :clearable="false"
            :default-value="form.incoTerm"
            @parentCallBack="p=>{form.incoTerm=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.paymentTermMBL.viewable" slot="paymentTermMBL">
          <line-label slot="label" :class="elementDict.paymentTermMBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermMBL.label" />
          <cargo-advance-select
            no="paymentTermMBL"
            :select-type="selectTypeNames.basic_data_PaymentTerm"
            filterable
            :disabled="!elementDict.paymentTermMBL.writable"
            :clearable="false"
            :default-value="form.paymentTermMBL"
            @parentCallBack="p=>{form.paymentTermMBL=p.value;}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField1.viewable" slot="userDefinedField1">
          <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
          <el-input
            v-model="form.userDefinedField1"
            no="userDefinedField1"
            type="textarea"
            :rows="5"
            :disabled="!elementDict.userDefinedField1.writable"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField2.viewable" slot="userDefinedField2">
          <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
          <el-input
            v-model="form.userDefinedField2"
            no="userDefinedField2"
            type="textarea"
            :rows="5"
            :disabled="!elementDict.userDefinedField2.writable"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField3.viewable" slot="userDefinedField3">
          <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
          <el-input
            v-model="form.userDefinedField3"
            no="userDefinedField3"
            type="textarea"
            :rows="5"
            :disabled="!elementDict.userDefinedField3.writable"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField4.viewable" slot="userDefinedField4">
          <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
          <el-input
            v-model="form.userDefinedField4"
            no="userDefinedField4"
            type="textarea"
            :rows="5"
            :disabled="!elementDict.userDefinedField4.writable"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.exportControlledProduct && elementDict.exportControlledProduct.masterVisible" slot="exportControlledProduct">
          <line-label slot="label" :class="elementDict.exportControlledProduct.isRequire ? 'blue' : ''" :label="elementDict.exportControlledProduct.label" />
          <el-select
            v-model="form.exportControlledProduct"
            no="exportControlledProduct"
            :disabled="readonly || !elementDict.exportControlledProduct.writable"
            :placeholder="''"
            :clearable="true"
            size="mini"
          >
            <el-option
              v-for="(item,index) in EXPORT_CONTROLLED_PRODUCT"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.taxNature.viewable" slot="taxNature">
          <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
          <el-select
            v-model="form.taxNature"
            no="taxNature"
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
            :disabled="!elementDict.taxNature.writable"
          >
            <el-option
              v-for="(item,index) in TAX_NATURES"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
        <el-form-item v-if="elementDict.quantityContract.viewable" slot="quantityContract">
          <line-label slot="label" :class="elementDict.quantityContract.isRequire ? 'blue' : ''" :label="elementDict.quantityContract.label" />
          <div style="display: flex">
            <auto-number-input
              v-model="form.quantityContract"
              no="quantityContract"
              :precision="0"
              :min="0"
              :disabled="!elementDict.quantityContract.writable"
              @change="pm.jobContractQwcChange(1)"
            />
            <span style="padding:0 2px;">/</span>
            <auto-number-input
              ref="quantityActual"
              v-model="form.quantityActual"
              no="quantityActual"
              :precision="0"
              :disabled="pm.billChargeFlag || !elementDict.quantityContract.writable"
              :min="0"
              @change="quantityActualChange"
            />
            <span>PCS</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.weightContract.viewable" slot="weightContract">
          <line-label slot="label" :class="elementDict.weightContract.isRequire ? 'blue' : ''" :label="elementDict.weightContract.label" />
          <div style="display: flex">
            <auto-number-input
              v-model="form.weightContract"
              no="weightContract"
              :precision="3"
              :min="0"
              :disabled="!elementDict.weightContract.writable"
              @change="weightContractChange"
            />
            <span style="padding:0 2px;">/</span>
            <auto-number-input
              ref="weightActual"
              v-model="form.weightActual"
              no="weightActual"
              :precision="3"
              :disabled="pm.billChargeFlag || !elementDict.weightContract.writable"
              :min="0"
              @change="weightActualChange"
            />
            <span>KGS</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cubageContract.viewable" slot="cubageContract">
          <line-label slot="label" :class="elementDict.cubageContract.isRequire ? 'blue' : ''" :label="elementDict.cubageContract.label" />
          <div style="display: flex">
            <auto-number-input
              v-model="form.cubageContract"
              no="cubageContract"
              :precision="3"
              :min="0"
              :disabled="!elementDict.cubageContract.writable"
              @change="cubageContractChange"
            />
            <span style="padding:0 2px;">/</span>
            <auto-number-input
              ref="cubageActual"
              v-model="form.cubageActual"
              no="cubageActual"
              :precision="3"
              :disabled="!cubageActualEnabled || !elementDict.cubageContract.writable"
              :min="0"
              @change="cubageActualChange"
            />
            <span>CBM</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.packing.viewable" slot="packing">
          <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
          <cargo-packing-select
            no="packing"
            :default-value="form.packing"
            :disabled="!elementDict.packing.writable"
            @change="p=>{form.packing=p.value;pm.txtPackingChangeHandler()}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.insideQuantity.viewable" slot="insideQuantity">
          <line-label slot="label" :class="elementDict.insideQuantity.isRequire ? 'blue' : ''" :label="elementDict.insideQuantity.label" />
          <auto-number-input
            v-model="form.insideQuantity"
            no="insideQuantity"
            :precision="0"
            :min="0"
            :disabled="!elementDict.insideQuantity.writable"
            @valCallBack="(val)=>{
              form.insideQuantity = val
            }"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.insidePacking.viewable" slot="insidePacking">
          <line-label slot="label" :class="elementDict.insidePacking.isRequire ? 'blue' : ''" :label="elementDict.insidePacking.label" />
          <cargo-packing-select
            no="insidePacking"
            :default-value="form.insidePacking"
            :disabled="!elementDict.insidePacking.writable"
            @change="p=>{form.insidePacking=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.chargeWeight.viewable" slot="chargeWeight">
          <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
          <div style="display: flex">
            <auto-number-input
              v-model="form.chargeWeight"
              no="chargeWeight"
              :precision="3"
              style="flex:1"
              :disabled="!chargeWeightEnabled || !elementDict.chargeWeight.writable"
              :min="0"
              @change="pm.chargeWeightChange();"
            />
            <span>M/T</span>
          </div>
        </el-form-item>
        <template v-if="elementDict.cargoEnglishName.viewable" slot="cargoEnglishName">
          <el-form-item v-show="isEdit && elementDict.cargoEnglishName.writable">
            <div slot="label">
              <el-button
                no="Copy2"
                type="primary"
                :disabled="!elementDict.cargoEnglishName.writable"
                @click="transcribeDialog.visible=true"
              >{{ $t('SeaExport.Copy2') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item>
            <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
            <special-character-tip :texts="specialCharCheck.cargoEnglishName">
              <cargo-rich-textarea
                ref="cargoTextarea1"
                v-model="form.cargoEnglishName"
                :show-count="true"
                no="cargoEnglishName"
                :text-chars="0"
                :warning-count="-1"
                :disabled="!isEdit || !elementDict.cargoEnglishName.writable || !elementDict.cargoEnglishName.writable"
                wrap-symbol="r"
                auto-half-word
                :auto-uppercase="isUppercaseByConfig"
                style="height: 110px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{},true,{autoHalfWord: true,autoUppercase:isUppercaseByConfig})"
              />
            </special-character-tip>
          </el-form-item>
        </template>
        <el-form-item v-show="elementDict.mark.viewable" slot="mark">
          <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
          <special-character-tip :texts="specialCharCheck.mark">
            <cargo-rich-textarea
              ref="cargoTextarea2"
              v-model="form.mark"
              :show-count="true"
              no="mark"
              :text-chars="0"
              :warning-count="-1"
              wrap-symbol="r"
              auto-half-word
              :auto-uppercase="isUppercaseByConfig"
              :disabled="!isEdit || !elementDict.mark.writable"
              style="height: 110px"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{},true,{autoHalfWord: true,autoUppercase:isUppercaseByConfig})"
            />
          </special-character-tip>
        </el-form-item>
        <el-form-item v-if="elementDict.hsCode.viewable" slot="hsCode">
          <template>
            <div slot="label">
              <line-label slot="label" :class="elementDict.hsCode.isRequire ? 'blue' : ''" :label="elementDict.hsCode.label" />
              <br>
              <el-button
                v-show="isEdit"
                no="Search"
                type="primary"
                :disabled="!elementDict.hsCode.writable"
                @click="showHsCodeSearchDialog($t('Message.SelectHsCode'),p=>form.hsCode=p.code)"
              >{{ $t('SeaExport.Search') }}
              </el-button>
            </div>
            <el-input
              v-model="form.hsCode"
              no="hsCode"
              type="textarea"
              :rows="5"
              :disabled="!elementDict.hsCode.writable"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),form.hsCode,val=>{form.hsCode=val})"
            />
          </template>
        </el-form-item>
        <el-form-item v-if="elementDict.cargoChineseName.viewable" slot="cargoChineseName">
          <template>
            <div slot="label">
              <line-label slot="label" :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
              <br>
              <el-button
                v-show="isEdit"
                no="ChineseDescriptionOfGoods"
                type="primary"
                :disabled="!elementDict.cargoChineseName.writable"
                @click="showHsCodeSearchDialog($t('Message.SelectCargoChineseName'),p=>form.cargoChineseName=p.commodityName)"
              >{{ $t('SeaExport.Search') }}
              </el-button>
            </div>
            <cargo-rich-textarea
              v-model="form.cargoChineseName"
              :show-count="true"
              no="cargoChineseName"
              :disabled="!isEdit || !elementDict.cargoChineseName.writable"
              :auto-uppercase="false"
              :auto-half-word="false"
              wrap-symbol="r"
              style="height: 110px"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),form.cargoChineseName,val=>{form.cargoChineseName=val})"
            />
          </template>
        </el-form-item>
        <el-form-item v-if="elementDict.waybillInvoice.viewable" slot="waybillInvoice" :label="$t('CargoMsg.Cargo_waybillInvoice')">
          <line-label slot="label" :class="elementDict.waybillInvoice.isRequire ? 'blue' : ''" :label="elementDict.waybillInvoice.label" />
          <el-input
            v-model="form.waybillInvoice"
            no="waybillInvoice"
            type="textarea"
            :rows="5"
            :disabled="!elementDict.waybillInvoice.writable"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.salesOffice.viewable" slot="salesOffice">
          <line-label slot="label" :class="elementDict.salesOffice.isRequire ? 'blue' : ''" :label="elementDict.salesOffice.label" />
          <el-input :value="txtSalesOffice" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.sales.viewable" slot="sales">
          <line-label slot="label" :class="elementDict.sales.isRequire ? 'blue' : ''" :label="elementDict.sales.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-user-select
              ref="sales"
              no="sales"
              :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
              :default-value="form.sales||''"
              :static-options="salesList"
              :placeholder="salesPrompt"
              :merge-load="true"
              style="flex: 1"
              :disabled="!elementDict.sales.writable"
              @change="p=>{form.salesRecord = p.value;pm.salesChangeHandler(p);}"
            />&nbsp;
            <el-checkbox
              v-model="form.provisioned"
              no="provisioned"
              style="margin-left: 5px"
              :disabled="true"
            >{{ $t('SeaExport.Accrued') }}
            </el-checkbox>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cargoSalesId.viewable" slot="cargoSalesId">
          <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
          <cargo-user-select
            no="cargoSalesId"
            :method-params="{category:'role',shape:'salesOfGoods'}"
            :default-value="form.cargoSalesId||''"
            :merge-load="true"
            :disabled="!elementDict.cargoSalesId.writable"
            :static-options="cargoSalesList"
            @change="p=>{form.cargoSalesId=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.salesDepartment.viewable" slot="salesDepartment">
          <line-label slot="label" :class="elementDict.salesDepartment.isRequire ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
          <cargo-department-new-select
            no="salesDepartment"
            :disabled="readonly || !elementDict.salesDepartment.writable || !form.sales || !elementDict.salesDepartment.writable"
            :sales-id="Number(form.sales)"
            :office-id="form.salesOffice"
            :enables="true"
            :department-id="Number(form.salesDepartment)"
            @change="p=>{form.salesDepartment=p.value;}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.opOffice.viewable" slot="opOffice">
          <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
          <cargo-office-select
            no="opOffice"
            :disabled="(!isRegionalCommission && pm.isEntrustOrder(true)) || opOfficeDisabled || !elementDict.opOffice.writable"
            :is-regional-commission="isRegionalCommission"
            :office-id="Number(form.opOffice)"
            @change="p=>{form.opOffice=p.value;form.opDepartment=0;opOfficeChargeHandler();contractRuleFieldChange()}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.opDepartment.viewable" slot="opDepartment">
          <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
          <cargo-department-select
            no="opDepartment"
            :office-id="Number(form.opOffice)"
            :enables="true"
            :disabled="!elementDict.opDepartment.writable"
            :department-id="Number(form.opDepartment)"
            @change="p=>{form.opDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.op.viewable" slot="op">
          <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
          <cargo-user-select
            ref="op"
            no="op"
            :disabled="!elementDict.op.writable"
            :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
            :default-value="form.op||''"
            :merge-load="true"
            @change="p=>{form.op=p.value;pm.txtOPChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csrOffice.viewable" slot="csrOffice">
          <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
          <cargo-office-select
            no="csrOffice"
            :disabled="true"
            :office-id="Number(form.csrOffice)"
            @change="p=>{form.csrOffice=p.value;form.csrDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csrDepartment.viewable" slot="csrDepartment">
          <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
          <cargo-department-select
            no="csrDepartment"
            :office-id="Number(form.csrOffice)"
            :enables="true"
            :disabled="!elementDict.csrDepartment.writable"
            :department-id="Number(form.csrDepartment)"
            @change="p=>{form.csrDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csr.viewable" slot="csr">
          <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
          <cargo-user-select
            ref="csr"
            no="csr"
            :disabled="!elementDict.csr.writable"
            :method-params="{officeId:pm.isEntrustOrder||form.salesOffice===1?form.opOffice:form.salesOffice,category:'role',shape:'csr'}"
            :default-value="form.csr||''"
            :merge-load="true"
            @change="p=>{pm.csrChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.siteOP.viewable" slot="siteOP">
          <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
          <cargo-user-select
            ref="siteOp"
            no="siteOp"
            :disabled="!elementDict.siteOP.writable"
            :method-params="{officeId:form.opOffice,category:'role',shape:'siteOp'}"
            :default-value="form.siteOP||''"
            @change="p=>{pm.siteOpChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.overseaOp.viewable" slot="overseaOp">
          <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
          <cargo-user-select
            ref="overseaOp"
            no="overseaOp"
            :disabled="!elementDict.overseaOp.writable"
            :default-value="form.overseaOp||''"
            :method-params="{category:'role',shape:'overseaOp'}"
            :static-options="isHC ? null : overseaAgentUsersList"
            :merge-load="true"
            @change="p=>{form.overseaOp=p.value;pm.overseaOpChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.truckCsr.viewable" slot="truckCsr">
          <line-label slot="label" :class="elementDict.truckCsr.isRequire ? 'blue' : ''" :label="elementDict.truckCsr.label" />
          <cargo-user-select
            ref="truckCsr"
            no="truckCsr"
            :method-params="{officeId:form.opOffice,category:'role',shape:'truckCsr'}"
            :default-value="form.truckCsr||''"
            :merge-load="true"
            :disabled="!elementDict.truckCsr.writable"
            @change="p=>{pm.truckCsrChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dcOffice.viewable" slot="dcOffice">
          <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
          <cargo-office-select
            no="dcOffice"
            :disabled="true"
            :office-id="Number(form.dcOffice)"
            @change="p=>{form.dcOffice=p.value;form.dcDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dcDepartment.viewable" slot="dcDepartment">
          <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
          <cargo-department-select
            no="dcDepartment"
            :office-id="Number(form.dcOffice)"
            :enables="true"
            :disabled="!elementDict.dcDepartment.writable"
            :department-id="Number(form.dcDepartment)"
            @change="p=>{form.dcDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dc.viewable" slot="dc">
          <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
          <cargo-user-select
            ref="dc"
            no="dc"
            :disabled="!elementDict.dc.writable"
            :method-params="{officeId:form.opOffice,category:'role',shape:'doc'}"
            :default-value="form.dc||''"
            :merge-load="true"
            @change="p=>{pm.dcChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.planner.viewable" slot="planner">
          <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
          <cargo-user-select
            no="planner"
            :disabled="!elementDict.planner.writable"
            :method-params="{officeId:form.opOffice,category:'role',shape:'seaLine'}"
            :default-value="form.planner||''"
            :merge-load="true"
            @change="p=>{form.planner=p.value;pm.txtPlannerChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId1.viewable" slot="userDefinedRoleId1">
          <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
          <cargo-user-select
            ref="userDefinedRoleId1"
            no="userDefinedRoleId1"
            :disabled="!elementDict.userDefinedRoleId1.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
            :default-value="form.userDefinedRoleId1||''"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleId1Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId2.viewable" slot="userDefinedRoleId2">
          <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
          <cargo-user-select
            ref="userDefinedRoleId2"
            no="userDefinedRoleId2"
            :disabled="!elementDict.userDefinedRoleId2.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
            :default-value="form.userDefinedRoleId2||''"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleId2Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId3.viewable" slot="userDefinedRoleId3">
          <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
          <cargo-user-select
            ref="userDefinedRoleId3"
            no="userDefinedRoleId3"
            :disabled="!elementDict.userDefinedRoleId3.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
            :default-value="form.userDefinedRoleId3||''"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleIdHandler(p, 'userDefinedRoleId3', 'userDefinedRoleDept3', 'userDefinedRoleOffice3', 'userDefinedRole3')}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId4.viewable" slot="userDefinedRoleId4">
          <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
          <cargo-user-select
            ref="userDefinedRoleId4"
            no="userDefinedRoleId4"
            :disabled="!elementDict.userDefinedRoleId4.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
            :default-value="form.userDefinedRoleId4||''"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleIdHandler(p, 'userDefinedRoleId4', 'userDefinedRoleDept4', 'userDefinedRoleOffice4', 'userDefinedRole4')}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId5.viewable" slot="userDefinedRoleId5">
          <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
          <cargo-user-select
            ref="userDefinedRoleId5"
            no="userDefinedRoleId5"
            :disabled="!elementDict.userDefinedRoleId5.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
            :default-value="form.userDefinedRoleId5||''"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleIdHandler(p, 'userDefinedRoleId5', 'userDefinedRoleDept5', 'userDefinedRoleOffice5', 'userDefinedRole5')}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId6.viewable" slot="userDefinedRoleId6">
          <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
          <cargo-user-select
            ref="userDefinedRoleId6"
            no="userDefinedRoleId6"
            :disabled="!elementDict.userDefinedRoleId6.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
            :default-value="form.userDefinedRoleId6||''"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleIdHandler(p, 'userDefinedRoleId6', 'userDefinedRoleDept6', 'userDefinedRoleOffice6', 'userDefinedRole6')}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId7.viewable" slot="userDefinedRoleId7">
          <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
          <cargo-user-select
            ref="userDefinedRoleId7"
            no="userDefinedRoleId7"
            :disabled="!elementDict.userDefinedRoleId7.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
            :default-value="form.userDefinedRoleId7||''"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleIdHandler(p, 'userDefinedRoleId7', 'userDefinedRoleDept7', 'userDefinedRoleOffice7', 'userDefinedRole7')}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable" slot="userDefinedRoleId8">
          <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
          <cargo-user-select
            ref="userDefinedRoleId8"
            no="userDefinedRoleId8"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
            :default-multiple-value="toNumArray(form.userDefinedRoleId8)"
            :multiple="true"
            :merge-load="true"
            :placeholder="readonly ? ' ' : ''"
            @change="p=>{form.userDefinedRoleId8=toTxt(p.value)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.operationContent.viewable" slot="operationContent">
          <line-label slot="label" :class="elementDict.operationContent.isRequire ? 'blue' : ''" :label="elementDict.operationContent.label" />
          <el-tooltip
            :content="form.operationContent"
            placement="left"
          >
            <div
              slot="content"
              v-html="form.operationContent ? form.operationContent.replace(/[\n]/g,'</br>') : $t('SeaExport.NoData')"
            />
            <el-input
              no="operationContent"
              :value="form.operationContent"
              :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddOperationRequirements')"
              type="textarea"
              :rows="4"
              :disabled="!elementDict.operationContent.writable"
              @dblclick.native="selectOperationReqDialog.value=form.operationContent;selectOperationReqDialog.visible=isEdit"
            />
          </el-tooltip>
        </el-form-item>
        <el-form-item v-if="elementDict.operationTips.viewable" slot="operationTips">
          <line-label slot="label" :class="elementDict.operationTips.isRequire ? 'blue' : ''" :label="elementDict.operationTips.label" />
          <el-input
            v-model="form.operationTips"
            no="operationTips"
            type="textarea"
            :disabled="!elementDict.operationTips.writable"
            :rows="4"
          />
        </el-form-item>
        <el-form
          v-show="elementDict.shipper.viewable"
          slot="shipper"
          :disabled="readonly || !elementDict.shipper.writable"
          label-width="50px"
          label-position="right"
          style="margin-right: 10px"
        >
          <el-form-item>
            <template slot="label">
              <line-label :class="elementDict.shipper.isRequire ? 'blue' : ''" :label="elementDict.shipper.label" />
              <char-count :form="form" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <cargo-company-select
              no="shipperId"
              :method-params="{shipper:true,active:true,companyLob:'integratedJob'}"
              :default-value="form.shipperId||''"
              style="display: inline-block;width: 175px;"
              @change="data => {pm.shipperChange(data)}"
            />&nbsp;
            <el-button
              no="shipperBillAddress"
              type="primary"
              @click="billAddressDialog.visible=true"
            >{{ $t('SeaExport.CodeSearching') }}</el-button>
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" label-width="0">
            <cargo-input
              :ref="'shipperLine'+i"
              v-model="form['shipperLine'+i]"
              :no="'shipperLine'+i"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="()=>wrapAddr(form,'shipperLine'+i,i+1 > 6 ? null :'shipperLine'+(i+1),'')"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,notUppercaseShipperConsigneNotify,null)"
            />
          </el-form-item>
        </el-form>
        <el-form
          v-show="elementDict.consignee.viewable"
          slot="consignee"
          :disabled="readonly || !elementDict.consignee.writable"
          label-width="50px"
          label-position="right"
          style="margin-right:10px"
        >
          <el-form-item>
            <template slot="label">
              <line-label :class="elementDict.consignee.isRequire ? 'blue' : ''" :label="elementDict.consignee.label" />
              <char-count :form="form" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <cargo-company-select
              no="consigneeId"
              :method-params="{consignee:true,active:true,companyLob:'integratedJob'}"
              :default-value="form.consigneeId||''"
              style="display: inline-block;width:175px;"
              @change="data => {pm.consigneeChange(data)}"
            />&nbsp;
            <el-button
              no="consigneeBillAddress"
              type="primary"
              @click="billAddressDialog.visible=true"
            >{{ $t('SeaExport.CodeSearching') }}</el-button>
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" label-width="0">
            <cargo-input
              :ref="'consigneeLine'+i"
              v-model="form['consigneeLine'+i]"
              :no="'consigneeLine'+i"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="()=>wrapAddr(form,'consigneeLine'+i,i+1 > 6 ? null :'consigneeLine'+(i+1),'')"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,notUppercaseShipperConsigneNotify,null)"
            />
          </el-form-item>
        </el-form>
        <el-form
          v-show="elementDict.notify.viewable"
          slot="notify"
          :disabled="readonly || !elementDict.notify.writable"
          label-width="50px"
          label-position="right"
          style="margin-right:10px"
        >
          <el-form-item>
            <template slot="label">
              <line-label :class="elementDict.notify.isRequire ? 'blue' : ''" :label="elementDict.notify.label" />
              <char-count :form="form" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <cargo-company-select
              no="notifyId"
              :method-params="{notify:true,active:true,companyLob:'integratedJob'}"
              :default-value="form.notifyId||''"
              style="display: inline-block;width:175px;"
              @change="data => {pm.notifyChange(data)}"
            />&nbsp;
            <el-button
              no="noconifyBillAddress"
              type="primary"
              @click="billAddressDialog.visible=true"
            >{{ $t('SeaExport.CodeSearching') }}</el-button>
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" label-width="0">
            <cargo-input
              :ref="'notifyLine'+i"
              v-model="form['notifyLine'+i]"
              :no="'notifyLine'+i"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="()=>wrapAddr(form,'notifyLine'+i,i+1 > 6 ? null :'notifyLine'+(i+1),'')"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,notUppercaseShipperConsigneNotify,null)"
            />
          </el-form-item>
        </el-form>
        <div v-if="elementDict.alsoNotify.viewable" slot="alsoNotify">
          <line-label :class="elementDict.alsoNotify.isRequire ? 'blue' : ''" style="display:inline-block;line-height:28px;padding-bottom: 5px;" :label="elementDict.alsoNotify.label" />
          <br>
          <cargo-rich-textarea
            v-model="form.alsoNotify"
            :disabled="readonly || !elementDict.alsoNotify.writable"
            no="alsoNotify"
            :text-chars="0"
            style="width: 310px;height: 230px;"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.SecondNotifyParty'),form.alsoNotify,val=>{form.alsoNotify=val},notUppercaseShipperConsigneNotify,null)"
          />
        </div>
        <div slot="ticketsInfo" class="section" style="width: 100%;">
          <div class="title">
            {{ $t('SeaExport.TicketsInfo') }}
            <div ref="division" class="division" :style="{height:divisionHeight+'px'}" @mousedown="divisionEnabled=true">
              <div class="line" style="margin-top:2px" />
              <div class="line" />
            </div>
          </div>
          <div style="display:flex;flex-direction:column;margin-bottom: 5px;line-height: 28px;">
            <div style="padding:5px 0">
              <span style="margin-right: 5px;">{{ $t('SeaExport.TotalTickets') }}:</span><span style="margin-right: 5px;">{{ form.lclSlaves.length }}</span>
              <div v-show="readonly" style="display: inline-flex;">
                <el-button
                  no="AddTickets"
                  type="primary"
                  @click="btnImportLclClickHandler"
                >{{ $t('SeaExport.AddTickets') }}</el-button>
                <el-button
                  no="RemoveTickets"
                  type="danger"
                  @click="pm.btnRemoveBatchClickHandler()"
                >{{ $t('SeaExport.RemoveTickets') }}</el-button>
              </div>
            </div>
            <div ref="slaveDiv" style="display: flex;">
              <cargo-ag-grid
                config-module="130125"
                :grid-options="gridOptions"
                :column-defs="columnDefs"
                :row-data="rowData"
                @gridReady="params=>{gridApi=params.api}"
              />
            </div>
          </div>
        </div>
      </tab-international-card-base-master-UICustom-layout>
    </div>
    <!-- 加入拼箱工作单查询弹窗 -->
    <query-ie-lcl-dialog
      :visible.sync="queryIeLclDialog.visible"
      :job="form"
      @callback="rows=>{pm.slaveAddedHandler(rows)}"
    />
    <!-- 票数填写弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="ticketDialog"
      :visible.sync="ticketDialog.visible"
      :title="$t('SeaExport.FillInQuantityOfVotes')"
      width="270px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="50px" label-position="right">
        <el-form-item :label="$t('SeaExport.Number')+'：'">
          <el-input-number v-model="ticketDialog.value" :precision="0" :min="1" :max="50" :controls="false" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="ticketDialogConfirm" type="primary" @click="toAddTicket">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="ticketDialogCancel" type="primary" @click="ticketDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 198px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="advanceTextDialogConfirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- SOP接收人弹窗 -->
    <sop-dialog
      :visible.sync="sopDialog.visible"
      :cmp-idx="sopDialog.cmpIdx"
      :job="form"
      :agent="sopDialog.agent"
      lob="IE"
      :contact-list="sopDialog.contactList"
      @updateJob="$emit('updateJob')"
    />
    <!-- 抄录弹窗 -->
    <transcribe-dialog
      :visible.sync="transcribeDialog.visible"
      :job="form"
      @callback="transcribeCallback"
    />
    <!-- HS编号和中文品名检索弹窗 -->
    <hs-code-search-dialog
      :visible.sync="hsCodeSearchDialog.visible"
      :title="hsCodeSearchDialog.title"
      @callback="hsCodeSearchDialog.successCallback"
    />
    <!-- 操作要求弹窗 -->
    <select-operation-req-dialog
      :visible.sync="selectOperationReqDialog.visible"
      lob="IE"
      :value="selectOperationReqDialog.value"
      @callback="val=>form.operationContent=val"
    />

    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="form"
      @callback="codeSearchCallback"
    />
    <!-- 订舱章弹窗 -->
    <stamp-picture-view
      :visible.sync="stampPictureView.visible"
      :business-documents="stampPictureView.businessDocuments"
    />
  </div>
</template>

<script>
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabInternationalCardBaseMasterUICustomLayout from '@/views/cargo/v0/Integrated/components/booking/tabs/tabInternationalCardBaseMasterUICustomLayout.vue'
import tabInternationalCardBaseMaster from '@/views/cargo/v0/Integrated/components/booking/tabs/tabInternationalCardBaseMaster.vue'
import StrUtils from '@/utils/StrUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import microApp from '@micro-zoe/micro-app'
import tabInternationalCardBaseUICustomLayout
  from '@/views/cargo/v0/Integrated/components/booking/tabs/tabInternationalCardBaseUICustomLayout.vue'
import { toNumArray, toTxt } from '@/utils/commonUtil'

export default {
  name: 'TabInternationalCardBaseMasterUICustom',
  components: { tabInternationalCardBaseUICustomLayout, cargoTextarea, tabInternationalCardBaseMasterUICustomLayout },
  extends: tabInternationalCardBaseMaster,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      userDefinedRoleDataUI: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.form ? this.form.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      }
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    },
    'form.exportControlledProduct': {
      immediate: true,
      handler(val) {
        if (val === 0) {
          this.form.exportControlledProduct = ''
        }
      }
    }
  },
  async created() {
    this.loadPageConfig()
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify()
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        UICustomUtil.handleViewAndWrite(UICustomConstants.INTEGRATED_IC_BOOKING, this.elementDict, row, true)
      }
    },
    loadPageConfig() {
      const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.INTEGRATED_IC_BOOKING, this.$store.getters.currentOfficeId, true)
      this.elementBlocks = pageConfig.elementBlocks
      this.elementDict = pageConfig.elementDict
      this.fieldDict = pageConfig.fieldDict
    },
    async getSubmitData() {
      const form = this.form
      for (const key in this.elementDict) {
        const element = this.elementDict[key]
        if (!element.viewable || !element.writable || !element.isRequire) {
          continue
        }
        if (!element.fieldNames) {
          continue
        }
        for (const fieldName of element.fieldNames) {
          const field = this.fieldDict[fieldName]
          if (fieldName === 'agentRefNo') {
            if (form.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
              continue
            }
          }
          if (fieldName === 'projectName' || fieldName === 'projectBatch') {
            continue
          }
          if (fieldName === 'designationAgent' && form.cargoSource !== 'NC') {
            continue
          }
          if (fieldName === 'shipper') {
            let shipperLine = ''
            for (let i = 1; i <= 7; ++i) {
              shipperLine += form['shipperLine' + i]
            }
            if (StrUtils.isEmpty(shipperLine) || StrUtils.isEmpty(form.shipperCode)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabInternationalCardMaster')
            }
            continue
          }
          if (fieldName === 'consignee') {
            let consigneeLine = ''
            for (let i = 1; i <= 7; ++i) {
              consigneeLine += form['consigneeLine' + i]
            }
            if (StrUtils.isEmpty(consigneeLine) || StrUtils.isEmpty(form.consigneeCode)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabInternationalCardMaster')
            }
            continue
          }
          if (fieldName === 'notify') {
            let notifyLine = ''
            for (let i = 1; i <= 7; ++i) {
              notifyLine += form['notifyLine' + i]
            }
            if (StrUtils.isEmpty(notifyLine) || StrUtils.isEmpty(form.notifyCode)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabInternationalCardMaster')
            }
            continue
          }
          if (fieldName.startsWith('shipperLine') || fieldName.startsWith('consigneeLine') || fieldName.startsWith('notifyLine')) {
            continue
          }
          if (fieldName.startsWith('shipperCode') || fieldName.startsWith('consigneeCode') || fieldName.startsWith('notifyCode')) {
            continue
          }
          if (fieldName === 'transferPortCode') {
            if (form.transfering && StrUtils.isEmpty(form.transferPortCode)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabInternationalCardMaster')
            }
          } else if (fieldName === 'taxNature') {
            if (form[fieldName] === '' || form[fieldName] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else {
            if (typeof form[fieldName] !== 'boolean' && StrUtils.isEmpty(form[fieldName])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabInternationalCardMaster')
            }
          }
        }
      }
      if (this.elementDict.carryingCmp && this.elementDict.carryingCmp.viewable && this.elementDict.carryingCmp.writable && this.elementDict.carryingCmp.isRequire) {
        if (!this.form.carryingCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.carryingCmp.label]), 'tabInternationalCardMaster')
        }
      }
      if (this.elementDict.warehouseCmp && this.elementDict.warehouseCmp.viewable && this.elementDict.warehouseCmp.writable && this.elementDict.warehouseCmp.isRequire) {
        if (!this.form.warehouseCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.warehouseCmp.label]), 'tabInternationalCardMaster')
        }
      }
      if (this.elementDict.warehouseName && this.elementDict.warehouseName.viewable && this.elementDict.warehouseName.writable && this.elementDict.warehouseName.isRequire && this.openWarehouse) {
        if (StrUtils.isEmpty(this.form.warehouseName)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.warehouseName.label]), 'tabInternationalCardMaster')
        }
      }
      this.superFunction = this.$options.extends.methods.getSubmitData
      return await this.superFunction()
    },
    setUserDefinedRoleDataUI() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData3.fieldData = this.form.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = this.userPortRoleData.userDefinedRole3
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-se-master-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData4.fieldData = this.form.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = this.userPortRoleData.userDefinedRole4
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-se-master-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChangeUI(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleDataUI()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.form.userDefinedRoleId3 = e.detail.data.fieldData
            this.pm.userDefinedRoleId3Handler(this.form.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.form.userDefinedRoleId4 = e.detail.data.fieldData
            this.pm.userDefinedRoleId4Handler(this.form.userDefinedRoleId4)
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .poNoClass {
    /deep/ .el-input.is-disabled .el-input__inner {
      color: red !important;
    }
  }
  /deep/ .also-notify {
    width: 310px;
    .el-textarea__inner {
      height: 230px;
    }
  }
</style>
